<template>
  <div>
    <div class="sixteentosix omt-6 omt-md-25 otp-screen-wrap">
      <div
        class="kachelimage header-image"
        style="background: url('/static/img/header_homepage.jpg')"
      >
        <div v-if="!loading" class="otp-white-wrapper download-doc-wrapper">
         
<h2 class="otp-head" v-if="newAddedDocuments.length > 0">
            {{ $t("newly_added_documents") }}
          </h2>
          <ul
            v-if="newAddedDocuments"
            class="pdf-list-wrap"
            v-for="document in newAddedDocuments"
            :key="document"
          >
            <li>
              <div class="file-name">
                <v-icon>fa-regular fa-file-pdf</v-icon>
                <a @click="showFile(document)">{{
                  getUploadedFileName(document)
                }}</a>
              </div>
              <v-btn
                outlined
                depressed
                tile
                class="savebutton"
                @click="showFile(document)"
                >{{ $t("download") }}
                <v-icon>fa-solid fa-download</v-icon></v-btn
              >
            </li>
          </ul>

          <h2
            class="otp-head"
            v-if="documents.length > 0 || originalDocuments.length > 0"
          >
            {{ $t("downloadDocuments") }}
          </h2>
          <p
            v-if="
              !loading &&
              newAddedDocuments.length === 0 &&
              documents.length === 0 &&
              originalDocuments.length === 0
            "
          >
            {{ $t("noDocuments") }}
          </p>

          <ul
            v-if="documents"
            class="pdf-list-wrap"
            v-for="document in documents"
            :key="document"
          >
            <li>
              <div class="file-name">
                <v-icon>fa-regular fa-file-pdf</v-icon>
                <a @click="showFile(document)">{{
                  getUploadedFileName(document)
                }}</a>
              </div>
              <v-btn
                outlined
                depressed
                tile
                class="savebutton"
                @click="showFile(document)"
                >{{ $t("download") }}
                <v-icon>fa-solid fa-download</v-icon></v-btn
              >
            </li>
          </ul>

          <ul
            v-if="originalDocuments"
            class="pdf-list-wrap"
            v-for="document in originalDocuments"
            :key="document"
          >
            <li>
              <div class="file-name">
                <v-icon>fa-regular fa-file-pdf</v-icon>
                <a @click="showFile(document)">{{
                  getUploadedFileName(document)
                }}</a>
              </div>
              <v-btn
                outlined
                depressed
                tile
                class="savebutton"
                @click="showFile(document)"
                >{{ $t("download") }}
                <v-icon>fa-solid fa-download</v-icon></v-btn
              >
            </li>
          </ul>
          
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      trainingId: null,
      bookingId: null,
      eventId: null,
      otp: null,
      documents: [],
      originalDocuments: [],
      newAddedDocuments: [],
      loading: true, // <-- Add this
    };
  },
  beforeMount() {
    showLoadingCircle(true);
  },
  mounted() {
    var _this = this;
    this.documentChange = this.$route.query.documentChange;
    this.trainingId = this.$route.query.trainingId;
    this.bookingId = this.$route.query.bookingId;
    this.otp = this.$route.query.otp;
    this.eventId = this.$route.query.eventId;
    let bookingId = parseInt(_this.bookingId);
    let trainingId = parseInt(_this.trainingId);
    let eventId = parseInt(_this.eventId);
    let otp = parseInt(_this.otp);
    if (!this.documentChange) {
      progressIndicator.hidden = false;
      showLoadingCircle(true);
      this.$axios
        .get(
          "/api/booking/downloadDocument/" +
            trainingId +
            "/" +
            bookingId +
            "/" +
            eventId +
            "/" +
            otp
        )
        .then(function (response) {
          _this.documents = response.data;
        })
        .catch(this.onError)
        .finally(() => {
          console.log("hello");
          _this.loading = false; // <-- Update this
          _this.onFinally();
        });
    } else {
      progressIndicator.hidden = false;
      showLoadingCircle(true);
      this.$axios
        .get(
          "/api/booking/downloadDocumentDocumentChange/" +
            trainingId +
            "/" +
            bookingId +
            "/" +
            eventId +
            "/" +
            otp
        )
        .then(function (response) {
          _this.originalDocuments = response.data.originalDocuments;
          _this.newAddedDocuments = response.data.newAddedDocuments;
        })
        .catch(this.onError)
        .finally(() => {
          console.log("hello");
          _this.loading = false; // <-- Update this
          _this.onFinally();
        });
    }
  },
  methods: {
    onError(err) {
      if (err.response != null && err.response.data != null) {
        this.$noty.error(err.response.data);
      } else {
        console.error(err);
      }
    },
    onFinally() {
      showLoadingCircle(false);
    },
    getUploadedFileName(fileName) {
      if (fileName.includes("__")) {
        return fileName.substring(fileName.indexOf("__") + 2);
      }
      return fileName;
    },
    showFile(fileName) {
      const nameString = fileName.toLowerCase();
      const internalFolder = "";
      var _this = this;
      if (
        nameString.endsWith(".png") ||
        nameString.endsWith(".jpeg") ||
        nameString.endsWith(".jpg") ||
        nameString.endsWith(".pdf") ||
        nameString.endsWith(".gif") ||
        nameString.endsWith(".txt")
      ) {
        var win = window.open(
          "/files/images/" + internalFolder + fileName,
          "_blank"
        );
        win.focus();
      } else {
        window.open("/files/images/" + internalFolder + fileName);
      }
    },
  },
};
</script>
